import {Directive, HostBinding, Input} from "@angular/core";

@Directive()
export class FUIAbstractLabel {
    @HostBinding("class.disabled") @Input() public disabled: boolean;
    @HostBinding("class.focussed") @Input() public focussed: boolean;
    @HostBinding("class.hovered") @Input() public hovered: boolean;
    @HostBinding("class.provided") @Input() public title: string;
    @HostBinding("class.valued") @Input() public valued: boolean;
    @Input() public i18NParams: any = {};
}
